import { createSelector } from "reselect";
import { type State } from "./data.state";

export const getData = (state): State => state.data;

export const getLearningPaths = createSelector(
  getData,
  (data) => data.learningPath
);
export const getCourses = createSelector(getData, (data) => data.course);
export const getModules = createSelector(getData, (data) => data.module);
export const getLessons = createSelector(getData, (data) => data.lesson);
export const getWorkouts = createSelector(getData, (data) => data.workout);
export const getSlides = createSelector(getData, (data) => data.slide);
